module.exports = __webpack_public_path__ + "media/home-family.6ddbb12f.mp4";